import styled from 'styled-components';
import { spacings } from '../../tokens/spacings';

export const BrowseWrapper = styled.main`
  column-gap: ${spacings.X_LARGE};
  padding: ${spacings.X_LARGE};

  display: flex;
  flex-direction: column;
  row-gap: ${spacings.MEDIUM};
`;
